import React from 'react'
import Card from 'react-bootstrap/Card'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Badge } from 'react-bootstrap'
import { useAccessManagementCounts } from 'api/hooks/use-access-management-counts'
import { calculatePercent } from 'helpers/utils'


const DiffBadge = ({ diff, subtext }) => {
  const value = Math.abs(diff)

  return (
    <Badge
      pill
      className={`text-center fw-normal ${'text-secondary badge-secondary'}`}
    >
      <span className="ms-1">
        {value}% {subtext}
      </span>
    </Badge>
  )
}

function Stats() {
  const { isSuccess, data: sodCounts } = useAccessManagementCounts({})

  const stats = isSuccess
    ? [
        {
          name: 'Roles Creating Conflicts',
          value: sodCounts?.roles_creating_conflicts_count,
          diff: calculatePercent(
            sodCounts?.roles_creating_conflicts_count,
            sodCounts?.roles_count
          ),
          subtext: 'of All Roles'
        },
        {
          name: 'Roles with Internal Conflicts',
          value: sodCounts?.roles_internal_conflicts_count,
          diff: calculatePercent(
            sodCounts?.roles_internal_conflicts_count,
            sodCounts?.roles_count
          ),
          subtext: 'of All Roles'
        },
        {
          name: 'Users with High Risk Permissions',
          value: sodCounts?.users_high_risk_permissions_count,
          diff: calculatePercent(
            sodCounts?.users_high_risk_permissions_count,
            sodCounts?.active_users_count
          ),
          subtext: 'of Active Users'
        },
        {
          name: 'Users with Super User Permissions',
          value: sodCounts?.superuser_permissions_count,
          diff: calculatePercent(
            sodCounts?.superuser_permissions_count,
            sodCounts?.active_users_count
          ),
          subtext: 'of Active Users'
        }
      ]
    : []

  return (
    <>
      <Row>
        {isSuccess &&
          stats.map((stat, index) => (
            <Col key={index} sm={3}>
              <Card>
                <Card.Body>
                  <Row>
                    <Col sm="auto">
                      <h4>{stat.value}</h4>
                    </Col>
                    <Col>
                      {' '}
                      <span className="float-end">
                        <DiffBadge diff={stat.diff} subtext={stat.subtext} />
                      </span>
                    </Col>
                  </Row>

                  <Card.Text className="text-muted">{stat.name}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
      </Row>
    </>
  )
}

export default Stats
